import { render, staticRenderFns } from "./assessment-page.vue?vue&type=template&id=1ee1f411&scoped=true"
import script from "./assessment-page.vue?vue&type=script&lang=js"
export * from "./assessment-page.vue?vue&type=script&lang=js"
import style0 from "./assessment-page.vue?vue&type=style&index=0&id=1ee1f411&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee1f411",
  null
  
)

export default component.exports